import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { Loading } from "@/layouts/components/Loading";
import { RoutesList } from "@/router/routesList";
import { useGetUserByIdQuery, useUpdateUserMutation } from "@/store/api";
import { convertToUpdateDto, convertToViewModel } from "../common/mappers";
import { UserEditForm } from "./components/UserEditForm";
export var UserEditPage = function () {
    var userId = useParams().userId;
    var userGetState = useGetUserByIdQuery({ id: userId });
    var _a = useUpdateUserMutation(), userUpdateAction = _a[0], userUpdateState = _a[1];
    var saveFormHandler = function (data) {
        try {
            userUpdateAction({
                id: userId,
                userUpdateDto: convertToUpdateDto(data),
            });
        }
        catch (err) {
            console.error(err);
        }
    };
    var cancelFormHandler = function () {
        navigate(RoutesList.Users.getUsersList());
    };
    var navigate = useNavigate();
    useEffect(function () {
        if (userUpdateState.isSuccess) {
            navigate(RoutesList.Users.getUsersList());
        }
    }, [userUpdateState.isSuccess]);
    var isLoading = !(userGetState.isSuccess || userGetState.isUninitialized) ||
        !(userUpdateState.isSuccess || userUpdateState.isUninitialized);
    return (_jsxs(_Fragment, { children: [_jsx(Loading, { isActive: isLoading, loadingKey: "userEdit" }), userGetState.isSuccess && (_jsx(UserEditForm, { data: convertToViewModel(userGetState.data), onSave: saveFormHandler, onCancel: cancelFormHandler }))] }));
};
